<template>
  <b-alert
    :variant="variant"
    class="d-flex flex-column word-break"
    :class="customClasses"
    role="alert"
    :show="messages && messages?.length > 0"
  >
    <template v-if="Array.isArray(messages)">
      <div v-for="(message, index) in messages" :key="index" class="d-flex flex-column my-1">
        {{ message }}
      </div>
    </template>
    <div v-else>
      <div v-html="messages || '&nbsp;'"></div>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'BaseInlineAlert',
  props: {
    messages: {
      type: [String, Array],
      required: true,
    },
    variant: {
      type: String,
      default: 'danger',
    },
    customClasses: {
      type: String,
      default: '',
    },
  },
}
</script>
